export default "<div style=\"background-color: #ffffff;\">\r\n</div>\r\n";